import { render, staticRenderFns } from "./UserPasswordUpdate.vue?vue&type=template&id=a10c3c44&"
import script from "./UserPasswordUpdate.vue?vue&type=script&lang=js&"
export * from "./UserPasswordUpdate.vue?vue&type=script&lang=js&"
import style0 from "./UserPasswordUpdate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports